import { FC } from 'react'
import clsx from 'clsx'
import { KTSVG } from '../helpers/components'
import { HeaderNotificationsMenu } from './header-menus/HeaderNotificationsMenu'
import { HeaderUserMenu } from './header-menus/HeaderUserMenu'
import { useSelector } from 'react-redux'
import { UsuarioSymbol } from '../layout/UsuarioSymbol'
import { selectUsuarioActual } from '../../redux/slices/autenticacion/autenticacion.slice'

/**
 * Barra superior: icono de notificaciones + saludo y avatar del usuario.
 * Cada elemento abre su menu dropdown correspondiente.
 * Exporta tambien helpers visuales (BulletBlink, badges) que actualmente no se usan
 * en el render pero se conservan por compatibilidad de imports.
 */

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'

const Topbar: FC = () => {
  const usuarioActual = useSelector(selectUsuarioActual)
  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        {/* begin::Menu- wrapper */}
        <div
          className={clsx(
            'btn btn-icon btn-active-light-primary btn-custom position-relative',
            toolbarButtonHeightClass
          )}
          data-kt-menu-trigger='click'
          data-kt-menu-placement='bottom-end'>
          <KTSVG path='/svg/notifications.svg' className={toolbarButtonIconSizeClass} />
          {usuarioActual?.notificacionesNoLeidas ? (
            <>
              {/* <BulletBlink /> */}
              {/* <NotificacionBadgeSquare /> */}
              <NotificacionBadgeCircle />
            </>
          ) : null}
        </div>
        <HeaderNotificationsMenu />
        {/* end::Menu wrapper */}
      </div>
      {/* begin::User */}
      <div className={clsx('ms-2 d-flex align-items-center')} id='kt_header_user_menu_toggle'>
        {/* begin::Toggle */}

        <div
          className={clsx(
            'cursor-pointer w-auto d-flex justify-content-between align-items-center py-2 px-3'
          )}
          data-kt-menu-trigger='click'
          data-kt-menu-placement='bottom-end'>
          <div>
            <h6 className='text-gray-700 text-hover-primary'>Hola {usuarioActual?.nombre}</h6>
          </div>
          <div className='ms-4'>
            {usuarioActual ? (
              <UsuarioSymbol
                nombre={usuarioActual.nombre}
                primerApellido={usuarioActual.apellidoPaterno}
                perfil={usuarioActual.perfil}
                estatus={true}
                bullet={false}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
        <HeaderUserMenu />
        {/* end::Toggle */}
      </div>
      {/* end::User */}
    </div>
  )
}

export { Topbar }

export const BulletBlink = () => {
  return (
    <>
      <span className='position-absolute top-25 start-75 translate-middle badge badge-circle badge-light-primary badge-outline badge-sm fs-9 animation-blink'></span>
      <span className='position-absolute top-25 start-75 translate-middle bullet bullet-dot bg-primary h-10px w-10px animation-blink'></span>
    </>
  )
}

export const NotificacionBadgeSquare = () => {
  return (
    <span className='position-absolute top-25 start-75 translate-middle badge badge-square badge-primary badge-sm fs-8'>
      5
    </span>
  )
}

export const NotificacionBadgeCircle = () => {
  const usuarioActual = useSelector(selectUsuarioActual)
  return (
    <>
      <span className='position-absolute top-25 start-75 translate-middle  badge badge-circle badge-sm badge-danger'>
        {usuarioActual?.notificacionesNoLeidas}
      </span>
    </>
  )
}
